'use client';

import styled from '@emotion/styled';
import { useMemo } from 'react';
import { WebViewScreen } from '@diritto/common/app/webview-header.constant';
import { HELP_URL } from '@diritto/common/constants/url';
import { isPC, PCOffset } from 'constants/layout';
import { MutableHeaderLayout } from 'ui-components/layout/MutableHeaderLayout';
import { useInAppHeader } from 'ui-hooks/useInAppHeader';
import { useInAppStatusBar } from 'ui-hooks/useInAppStatusBar';
import { configure } from 'utils/configure';
import { useResponsiveImageMap } from 'ui-hooks/useResponsiveImageMap';
import { useViewPort } from 'ui-hooks/useViewPort';

export const ResultPage = ({ isApp }: { isApp?: boolean }) => {
  useInAppHeader({ screen: WebViewScreen.PickAndChoo, title: '2026 제 4회 픽앤츄' });
  useInAppStatusBar(WebViewScreen.PickAndChoo);

  const { width: screenWidth } = useViewPort();
  const contentWidth = useMemo(
    () => (screenWidth > PCOffset ? Math.min(screenWidth, 730) : screenWidth),
    [screenWidth],
  );

  const scale = useMemo(() => contentWidth / 730, [contentWidth]);
  const HELP_QNA_URL = `${HELP_URL}/hc/ko/articles/14598106894991-2026-픽앤츄`;
  useResponsiveImageMap('image2', 'image-map2');
  useResponsiveImageMap('image3', 'image-map3');

  return (
    <MutableHeaderLayout title="2026 제 4회 픽앤츄" noBottomPadding isApp={isApp}>
      <div className="relative flex flex-col items-center gap-0">
        <div className="flex justify-center w-full bg-[#EFEBFA]">
          <img
            alt="event"
            src={`${configure.staticPrefix}/images/contests/4/result/1.webp`}
            className="w-full h-auto"
          />
        </div>
        <div className="flex justify-center w-full bg-[#EFEBFA]">
          <img
            alt="event"
            id="image2"
            useMap="#image-map2"
            src={`${configure.staticPrefix}/images/contests/4/result/2_2.webp`}
            className="w-full h-auto"
          />
          <StyledScaleWrapper scale={scale} className="absolute left-0 w-full">
            <map name="image-map2">
              <area
                target="_self"
                alt="픽앤츄 작품 보러가기"
                title="픽앤츄 작품 보러가기"
                href="/sections/pick-and-choo-list"
                coords="125,10061,1043,10251"
                shape="rect"
              />
            </map>
          </StyledScaleWrapper>
        </div>
        <div className="flex justify-center w-full bg-white">
          <img
            alt="event"
            id="image3"
            useMap="#image-map3"
            src={`${configure.staticPrefix}/images/contests/4/result/3.webp`}
            className="w-full h-auto"
          />
          <StyledScaleWrapper scale={scale} className="absolute left-0 w-full">
            <map name="image-map3">
              <area
                target="_self"
                alt="프로그램 안내 및 상세 FAQ"
                title="프로그램 안내 및 상세 FAQ"
                href={HELP_QNA_URL}
                coords="125,921,1045,1108"
                shape="rect"
              />
            </map>
          </StyledScaleWrapper>
        </div>
      </div>
    </MutableHeaderLayout>
  );
};

export const StyledScaleWrapper = styled.div<{ scale: number }>`
  transform: scale(${({ scale = 0.3 }) => scale});
  transition: width 0.3s ease-in-out;

  @media (${isPC}) {
    transform: scale(1);
  }
`;
